module.exports = __webpack_public_path__ + "static/media/illustreation-step-6-put-in-box.0f9caaf0.svg";